/**
 * @desc 查询明细
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(params: API.wms.stockPool.detail.Params, options?: any) {
  return updateResponse(
    http(URL + `/stockPool/detail`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
